import { Component, OnDestroy, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { BaseComponent } from '../../_shared/components/base.component';
import { delay, tap, map, filter, takeWhile, take, switchMap } from 'rxjs/operators';
import { selectLoggedInUser, isLoggedIn, selectOrgLookups } from '../../_store/app.selectors';
import { AppState } from '../../_store/app-state.model';
import { Store, select } from '@ngrx/store';
import { AppSelectors } from '../../_store/selector-types';
import { ActivatedRoute, Router } from '@angular/router';
import { FilterService, SpinnerService } from '../../_shared/services/services-index';
import { environment } from '../../../environments/environment';
import * as constants from '../../_shared/constants/constants';
import { LayoutHelperService } from '../../_layout/layoutHelper.service';
import { UsersService } from '../../_shared/services/api/users.service';
import { HttpClient } from '@angular/common/http';
import { env } from 'process';
const clone = require('rfdc/default');

@Component({
    selector: 'sd-redirect',
    templateUrl: './redirect.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RedirectComponent extends BaseComponent implements OnInit, OnDestroy {

  componentActive: boolean = true;

  constructor(private store$: Store<AppState>,
    private userService: UsersService,
    private spinner: SpinnerService,
    public layoutHelper: LayoutHelperService,
    private readonly route: ActivatedRoute,
    private filterService: FilterService
  ) {
    super();
    this.filterService.setActivePageTitle('Redirecting. . .');

  }

  ngOnInit() {
    this.spinner.show();
    const app = this.route.snapshot.queryParams['app'];

    if (!!app) {
      this.openExternalTool(app);
    }
    else {
      console.error("No app specified.  Make sure your route configuration has a routeData.app setting.")
    }
  }

  ngOnDestroy() {
    this.componentActive = false;
  }

  openExternalTool(app: string) {

    if (app === constants.externalApps.RetailerTools) {
      let url = environment.retailerToolsBaseUri;
      if (!!environment.retailerToolsIncludeAuth) {
        this.store$.pipe(take(1), select(selectLoggedInUser)).subscribe(auth => {
          url += `/auth?userName=${auth.clientUserName}&firstName=${auth.firstName}&lastName=${auth.lastName}&role=${auth.role}&roleEntity=${auth.roleEntity}&handoffToken=a3iojd7adiou`;
          window.location.href = url;
        });
      }
      else {
        window.location.href = url;
      }
    }
    else if (app === constants.externalApps.MysteryShopV2) {
      console.log("Mystery Shop URL 2: ", environment.mysteryShopBaseUri);
      this.userService.getMysteryShopRedirectUrl().pipe(
        take(1)
      ).subscribe(response => {
        if (!!response) {
          console.log("Mystery Shop URL 2: ", response);
          window.location.href = response;
        }
        else {
          console.error("Could not determine MysteryShop redirect Url.")
        }
      });
    }
    else if (app === constants.externalApps.MazdaForceMarketingSite) {
      const url = "https://mazdadealermarketing.force.com/";
      window.location.href = url;
    }
    else if (app === constants.externalApps.Harmony) {
      this.userService.getHarmonyRedirectUrl().pipe(
        take(1)
      ).subscribe(response => {
        if (!!response) {
          window.location.href = response.toString();
        }
        else {
          console.error("Could not determine Harmony redirect Url ")
        }
      });
    }
    else {
      //treat 'app' as a url and navigate to it directly
      window.location.href = app;
    }
  }
}
